/**
 * API list endpoints respond either bare (`T[]`) or enveloped
 * (`{ data: T[], meta }`); normalize to the array. Undefined/null (query
 * not yet resolved) normalizes to empty.
 */
export const unwrapList = <T>(
  response: T[] | { data?: T[] } | null | undefined,
): T[] => (Array.isArray(response) ? response : (response?.data ?? []));
